import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import { IReferral } from "@/referrals/referral";

const ServiceCol = (): ColumnDef<IReferral> => ({
  header: "Service",
  accessorKey: "service_needed",
  cell: ({ getValue }) => {
    const serviceNeeded = getValue() as string;
    return <LineClampedTooltip>{serviceNeeded}</LineClampedTooltip>;
  },
});

export default ServiceCol;
